import { Container } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { deleteSport, getSport, restoreSport } from "../../../api";
import EditNewsForm from "../../EditNewsForm";
import { updateSport } from "../../../api";

export default function EditSport() {
  const location = useLocation();
  const navigate = useNavigate();

  const customSubmitFunction = async (id, title, description, image) => {
    try {
      const result = await updateSport(id, title, description, image);
      if (result) {
        navigate("/sports/all");
      }
    } catch (error) {}
  };
  const publishSport = async (id) => {
    try {
      await restoreSport(id);

      navigate("/sports/all");
    } catch (error) {
      throw error;
    }
  };
  const unPublishSport = async (id) => {
    try {
      await deleteSport(id);

      navigate("/sports/all");
    } catch (error) {
      throw error;
    }
  };
  const getOneSport = async (id) => {
    try {
      const result = await getSport(id);
      return result;
    } catch (error) {}
  };

  return (
    <>
      <Container>
        <EditNewsForm
          ItemId={location?.state?.sportid}
          breadCrumbLink={"Sport"}
          breadCrumbText={"Edit Sport"}
          goBackLink={"/sports/all"}
          customsubmit={customSubmitFunction}
          publishItem={publishSport}
          unPublishItem={unPublishSport}
          getOneItem={getOneSport}
        />
      </Container>
    </>
  );
}
